import { Component } from '@angular/core';
import { Router } from '@angular/router';

type JobType =
  | 'doctor'
  | 'dentist'
  | 'other'
  | 'engineer'
  | 'civil_engineer'
  | 'accountant'
  | 'nurse'
  | 'pharmacist'
  | 'medical_lab'
  | 'radiology'
  | 'admin_assistant'
  | 'receptionist'
  | 'customer_service'
  | 'sales'
  | 'marketing'
  | 'hr'
  | 'driver'
  | 'technician'
;

interface JobOption {
  value: JobType;
  route: string;
  labelKey: string;
  descriptionKey: string;
}

@Component({
  selector: 'app-upload-cv',
  templateUrl: './upload-cv.component.html',
  styleUrl: './upload-cv.component.scss'
})
export class UploadCVComponent {

  selectedJob: JobType | '' = '';
  errorMessageKey = '';

  jobOptions: JobOption[] = [
    {
      value: 'doctor',
      route: '/apply/doctor',
      labelKey: 'atw.uploadCv.jobs.doctor.label',
      descriptionKey: 'atw.uploadCv.jobs.doctor.description'
    },
    {
      value: 'dentist',
      route: '/apply/dentist',
      labelKey: 'atw.uploadCv.jobs.dentist.label',
      descriptionKey: 'atw.uploadCv.jobs.dentist.description'
    },
    {
      value: 'other',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.other.label',
      descriptionKey: 'atw.uploadCv.jobs.other.description'
    },
    {
      value: 'engineer',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.engineer.label',
      descriptionKey: 'atw.uploadCv.jobs.engineer.description'
    },
    {
      value: 'civil_engineer',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.civilEngineer.label',
      descriptionKey: 'atw.uploadCv.jobs.civilEngineer.description'
    },
    {
      value: 'accountant',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.accountant.label',
      descriptionKey: 'atw.uploadCv.jobs.accountant.description'
    },
    {
      value: 'nurse',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.nurse.label',
      descriptionKey: 'atw.uploadCv.jobs.nurse.description'
    },
    {
      value: 'pharmacist',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.pharmacist.label',
      descriptionKey: 'atw.uploadCv.jobs.pharmacist.description'
    },
    {
      value: 'medical_lab',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.medicalLab.label',
      descriptionKey: 'atw.uploadCv.jobs.medicalLab.description'
    },
    {
      value: 'radiology',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.radiology.label',
      descriptionKey: 'atw.uploadCv.jobs.radiology.description'
    },
    {
      value: 'admin_assistant',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.adminAssistant.label',
      descriptionKey: 'atw.uploadCv.jobs.adminAssistant.description'
    },
    {
      value: 'receptionist',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.receptionist.label',
      descriptionKey: 'atw.uploadCv.jobs.receptionist.description'
    },
    {
      value: 'customer_service',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.customerService.label',
      descriptionKey: 'atw.uploadCv.jobs.customerService.description'
    },
    {
      value: 'sales',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.sales.label',
      descriptionKey: 'atw.uploadCv.jobs.sales.description'
    },
    {
      value: 'marketing',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.marketing.label',
      descriptionKey: 'atw.uploadCv.jobs.marketing.description'
    },
    {
      value: 'hr',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.hr.label',
      descriptionKey: 'atw.uploadCv.jobs.hr.description'
    },
    {
      value: 'driver',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.driver.label',
      descriptionKey: 'atw.uploadCv.jobs.driver.description'
    },
    {
      value: 'technician',
      route: '/apply/any',
      labelKey: 'atw.uploadCv.jobs.technician.label',
      descriptionKey: 'atw.uploadCv.jobs.technician.description'
    }
  ];

  constructor(private router: Router) {}

  onJobChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value as JobType;

    this.selectedJob = value;
    this.errorMessageKey = '';

    const selectedOption = this.jobOptions.find(job => job.value === value);

    if (!selectedOption) {
      return;
    }

    this.navigateToJobForm(selectedOption);
  }

  selectJob(job: JobOption): void {
    this.selectedJob = job.value;
    this.errorMessageKey = '';
    this.navigateToJobForm(job);
  }

  goToSelectedForm(): void {
    if (!this.selectedJob) {
      this.errorMessageKey = 'atw.uploadCv.errors.required';
      return;
    }

    const selectedOption = this.jobOptions.find(job => job.value === this.selectedJob);

    if (!selectedOption) {
      this.errorMessageKey = 'atw.uploadCv.errors.invalid';
      return;
    }

    this.navigateToJobForm(selectedOption);
  }

  private navigateToJobForm(job: JobOption): void {
    this.router.navigate([job.route]);
  }

  trackByJobValue(index: number, job: JobOption): JobType {
    return job.value;
  }
}
